import { useDispatch, useSelector } from 'react-redux';
import { selectEventsData, setAnalyticsData, setEventDataList } from '../events/eventsSlice';
import {
  selectLandingType,
  selectPlan,
  selectPlanCoupon,
  selectShowCheckout,
  setCouponDetails,
  setPlan,
  setShowCheckout,
} from './plansSlice';
import { useEffect, useMemo } from 'react';
import { sendAnalyticsEvents } from '../../analytics/common';
import { EVENTS } from '../../analytics/events';
import { PLANS } from '../../analytics/eCommerce';
import DefaultPlans from './DefaultPlans';
import { useAnalyticsData } from '../checkout/helper';
import { COUPONS } from '../../analytics/coupons';
import HeadwayPlans from './HeadwayPlans';
import IntroOfferPlans from './IntroOfferPlans';

const PlansScreen = () => {
  const dispatch = useDispatch()
  const eventsData = useSelector(selectEventsData);
  const plan = useSelector(selectPlan)
  const showCheckout = useSelector(selectShowCheckout)
  const landingType = useSelector(selectLandingType);
  const couponDetails = useSelector(selectPlanCoupon);
  const analyticsParams = useAnalyticsData()
  const isHeadwayPlans = ['trial', 'up_v2'].includes(landingType);
  const isIntroOffer = landingType === 'intro_offer';
  useEffect(() => {
    dispatch(setAnalyticsData(analyticsParams))
  },[analyticsParams, dispatch]);
  useEffect(
    () => {
      !showCheckout &&
      sendAnalyticsEvents(EVENTS.onboardingPaywallShown, eventsData)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [showCheckout]
  )
  const handleSetPlan = (id, coupon) => {
		dispatch(setPlan(id));
		dispatch(
			setCouponDetails({
				couponPrice: COUPONS[coupon] || 0,
				couponName: coupon || '',
			})
		);
	};
  const planDetails = useMemo(() => PLANS[plan], [plan])

  const onContinueClick = () => {
    const { productId, duration, description, periodPrice, price } = planDetails
    const periodPriceWithCoupon = +(periodPrice - couponDetails.couponPrice).toFixed(2);
    const planData = {
      Value: price,
      value: Math.round(price * 100),
      currency: "USD",
      price: periodPrice,
      description,
      product_id: productId,
      duration,
      Duration: duration,
      periodPrice: periodPriceWithCoupon,
    };
    dispatch(setEventDataList(planData))
    sendAnalyticsEvents(EVENTS.onboardingPaywallChosen, {
      ...eventsData,
      ...planData,
    })
    dispatch(setShowCheckout(true))
  }

  if (isIntroOffer) {
    return (
      <IntroOfferPlans
        handleSetPlan={handleSetPlan}
        onContinueClick={onContinueClick}
      />
    );
  }


  if (isHeadwayPlans) {
    return (
      <HeadwayPlans
        handleSetPlan={handleSetPlan}
        onContinueClick={onContinueClick}
      />
    );
  }
  return (
    <DefaultPlans
			handleSetPlan={handleSetPlan}
			onContinueClick={onContinueClick}
		/>
  )
};

export default PlansScreen
